import { Result } from '@/app/tracking/tracking-api'
import { Bookmark } from './bookmark-state';

export type BookmarkErrorCode = 'query-error' | 'update-error';
export interface BookmarkError {
  code: BookmarkErrorCode;
  details: unknown;
}

export const BookmarkDataStoreSymbol = Symbol.for('BookmarkDataStore');
export interface BookmarkDataStore {
  get(): Promise<Result<Bookmark, BookmarkError>>;
  update(bookmark: Bookmark): Promise<Result<true, BookmarkError>>;
}
